import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/list-master/cities";

export const Route = createFileRoute("/admin/_list-master/cities")({
  component: Page,
});
